import { NegativeColors, PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { ColorSchemes } from 'redesignedComponents/context/colorScheme/enums';

import type { ColorSchemeType } from 'redesignedComponents/context/colorScheme/types';

const useStyles = createUseStyles<string, { colorScheme: ColorSchemeType }>(
  {
    headerSection: {
      borderRadius: FontSizes.s12,
    },
    wrapper: {
      background: ({ colorScheme }) => {
        return colorScheme === ColorSchemes.LIGHT
          ? NegativeColors.base.default
          : PositiveColors.base.default;
      },
      color: ({ colorScheme }) => {
        return colorScheme === ColorSchemes.LIGHT
          ? NegativeColors.text.default
          : PositiveColors.text.default;
      },

      textAlign: 'center',
      borderRadius: CornerRadius.r12,
      padding: [Spacings.s48, Spacings.s56],
      marginBottom: 100,
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s48, Spacings.s12],
      },
    },
    title: {
      textAlign: 'center',
      marginBottom: Spacings.s16,
      fontSize: FontSizes.s60,
      lineHeight: LineHeights.l72,
    },
    button: {
      marginTop: Spacings.s32,
      marginBottom: Spacings.s56,
      cursor: 'pointer',
      '@media screen and (max-width: 768px)': {
        marginBottom: Spacings.s48,
      },
    },

    carousel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s16,
      marginBottom: -100,
      '& > [class*="wrapper-"]': {
        width: 'auto',
        maxWidth: '100%',
      },
      '@media screen and (max-width: 768px)': {
        marginInline: '-12px',
      },
    },
    carouselItem: {
      position: 'relative',
      '@media screen and (max-width: 768px)': {
        '&:first-child': {
          marginInlineStart: Spacings.s32,
        },
        '&:last-child': {
          marginInlineEnd: Spacings.s32,
        },
      },
    },
    carouselTitle: {
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
      fontWeight: FontWeights.bold,
    },
    // skeleton
    skeletonRoot: {
      width: '100%',
      height: 554,
    },
  },
  {
    name: 'banner-carousel',
  },
);

export default useStyles;
